// import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
// import useStores from 'src/hooks/useStore';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
// 日期中文配置
dayjs.locale('zh-cn');

/**
 * 初始化函数
 * @param {*} props
 * @returns
 */
const Initialization = (props) => {
  return <ConfigProvider locale={zhCN}>{props.children}</ConfigProvider>;
};

export default observer(Initialization);
